import React, { Component } from "react";
import { Row, Col, Select, Space, Alert } from "antd";
import {
  Form,
  ModalItem,
  FormItem,
  InputItem,
  ButtonItem,
  ErrorItem,
  SelectItem,
  SwitchItem,
} from "../../../../../Components/Items";
import { TIPOS_CAMPO, ENTIDADES_REFERENCIA } from "../camposOrdenProduccion.utils";
import { PlusOutlined, DeleteOutlined } from "@ant-design/icons";

const { Option } = Select;

class ModalCampoOrdenProduccionPU extends Component {
  formRef = React.createRef();
  state = { opciones: [] };

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      if (this.props.campo) {
        this.formRef.current?.setFieldsValue(this.props.campo);
        this.setState({ opciones: this.props.campo.opciones || [] });
      } else {
        this.formRef.current?.resetFields();
        this.setState({ opciones: [] });
      }
    }
  }

  agregarOpcion = () => {
    this.setState((prev) => ({ opciones: [...prev.opciones, { etiqueta: "", valor: "" }] }));
  };

  cambiarOpcion = (index, campo, valor) => {
    this.setState((prev) => ({
      opciones: prev.opciones.map((opcion, i) => (i === index ? { ...opcion, [campo]: valor } : opcion)),
    }));
  };

  eliminarOpcion = (index) => {
    this.setState((prev) => ({ opciones: prev.opciones.filter((_, i) => i !== index) }));
  };

  onFinishFailed = (e) => ErrorItem(e);

  onFinish = (values) => {
    const campoFinal = {
      ...(this.props.campo || {}),
      ...values,
      opciones: values.tipo === "seleccion" ? this.state.opciones : [],
      origen: this.props.campo?.origen || "personalizado",
      estado: this.props.campo?.estado || 1,
    };
    this.props.onGuardar(campoFinal);
  };

  render() {
    const esSistema = this.props.campo?.origen === "sistema";

    return (
      <ModalItem
        title={this.props.campo ? "Editar campo" : "Agregar campo"}
        visible={this.props.visible}
        spinning={false}
        onCancel={this.props.onCancelar}
        paddingTop
      >
        <Form
          ref={this.formRef}
          name="ModalCampoOrdenProduccionPU"
          layout
          bottom={
            <ButtonItem type="primary" htmlType="submit" style={{ display: "block", margin: "0 0 0 auto" }}>
              Guardar
            </ButtonItem>
          }
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
        >
          <Row style={{ width: "100%" }}>
            <Col span={24}>
              {esSistema && (
                <Alert
                  type="info"
                  showIcon
                  message="Este es un campo sugerido por el sistema: solo puedes marcarlo obligatorio o no."
                  style={{ marginBottom: 16 }}
                />
              )}
              <FormItem name="etiqueta" label="Etiqueta" required max={100} margin pattern>
                <InputItem placeholder="Nombre visible del campo" disabled={esSistema} />
              </FormItem>
              <FormItem name="tipo" label="Tipo de dato" required margin initialValue="texto">
                <SelectItem placeholder="Selecciona el tipo de dato" disabled={esSistema}>
                  {TIPOS_CAMPO.map((tipo) => (
                    <Option key={tipo.value} value={tipo.value}>
                      {tipo.label}
                    </Option>
                  ))}
                </SelectItem>
              </FormItem>

              <FormItem shouldUpdate noStyle>
                {({ getFieldValue }) => {
                  const tipo = getFieldValue("tipo");

                  if (tipo === "referencia") {
                    return (
                      <FormItem name="entidadReferencia" label="Catálogo al que hace referencia" required margin>
                        <SelectItem placeholder="Selecciona el catálogo" disabled={esSistema}>
                          {ENTIDADES_REFERENCIA.map((entidad) => (
                            <Option key={entidad.value} value={entidad.value}>
                              {entidad.label}
                            </Option>
                          ))}
                        </SelectItem>
                      </FormItem>
                    );
                  }

                  if (tipo === "seleccion") {
                    return (
                      <div style={{ marginBottom: 16 }}>
                        <div style={{ marginBottom: 8, fontWeight: 600 }}>Opciones</div>
                        {this.state.opciones.map((opcion, index) => (
                          <Space key={index} style={{ display: "flex", marginBottom: 8 }} align="baseline">
                            <InputItem
                              placeholder="Etiqueta"
                              value={opcion.etiqueta}
                              onChange={(e) => this.cambiarOpcion(index, "etiqueta", e.target.value)}
                            />
                            <InputItem
                              placeholder="Valor"
                              value={opcion.valor}
                              onChange={(e) => this.cambiarOpcion(index, "valor", e.target.value)}
                            />
                            <DeleteOutlined onClick={() => this.eliminarOpcion(index)} />
                          </Space>
                        ))}
                        <ButtonItem icon={<PlusOutlined />} onClick={this.agregarOpcion} size="small">
                          Agregar opción
                        </ButtonItem>
                      </div>
                    );
                  }

                  return null;
                }}
              </FormItem>

              <FormItem name="obligatorio" label="¿Obligatorio?" margin valuePropName="checked" initialValue={false}>
                <SwitchItem />
              </FormItem>
            </Col>
          </Row>
        </Form>
      </ModalItem>
    );
  }
}

export default ModalCampoOrdenProduccionPU;
